export default __webpack_public_path__ + "img/homepage.section4.02.asset.ed911954.jpg";